module.exports = __webpack_public_path__ + "static/img/icon-camera.0f5d0e6a.svg";